import React  from 'react'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReleaseNoteModal from './ReleaseNoteModal';
import { downloadDefaultFile,deleteDefaultFile } from '../api/managefileapi';
import { useDispatch } from 'react-redux';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import swal from 'sweetalert';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs/plugin/utc';
import dayjsPluginTimezone from "dayjs/plugin/timezone";

dayjs.extend(dayjsPluginUTC);
dayjs.extend(dayjsPluginTimezone);

const columns = [
  { id: 'controllername', label: 'Controller' },
  { id: 'file_name', label: 'File Name' },
  { id: 'created_at', label: 'Created At' },
  { id: 'actions', label: 'Actions'}
];

export default function DefaultConfigFileHistoryItem({
  list,
  searchText,
  searchType
}) {

    const dispatch = useDispatch();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage]  = React.useState(10);
    const [open, setOpen] = React.useState(false);
    const [releaseNotes,setReleaseNotes] = React.useState('');
   
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    const handleRedirect =(rowId,fileName) => {
      dispatch(downloadDefaultFile(rowId,fileName));
    };

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      setOpen(false);
    };

    const handleDelete = (rowId) => {
      swal({
        title: "Are you sure?",
        text: "Are you sure you want to Delete File!",
        icon: "warning",
        buttons: ["Cancel", "OK"],
      })
      .then(willDelete => {
        if (willDelete) {
          dispatch(deleteDefaultFile(rowId,searchText,searchType));
        }
      });

    };

    return (
    <Box>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                { list?.length > 0 ?  list?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((row,i) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell width="100px" key={column.id} align={column.align}>
                              {column.format && typeof value === 'number'
                                ? column.format(value)
                                : column.id === 'actions' ?
                                <>
                                <Stack spacing={2} direction="row">
                                  <Tooltip title="View Release Notes">
                                    <VisibilityIcon 
                                      onClick={()=> handleClickOpen(setReleaseNotes(row.description))}
                                      sx={{cursor:'pointer'}}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Download">
                                    <DownloadIcon 
                                      onClick={(e) => handleRedirect(row['id'],row['file_name'])}
                                      sx={{cursor:'pointer'}}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <DeleteSharpIcon 
                                      color='error'
                                      onClick={(e) => handleDelete(row['id'])}
                                      sx={{cursor:'pointer'}}
                                    />
                                  </Tooltip>
                                </Stack>
                              </>
                            :  column.id === 'created_at' ? dayjs(row['created_at']).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss")  : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                }): <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
          { list?.length > 0 ?  
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={list?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            : <></> }
      </Paper>
      <ReleaseNoteModal
        open={open}
        onClose={handleClose}
        description={releaseNotes}
      />
    </Box>
  );
}
